import React, {useState, useEffect} from 'react'
import {useSearchParams} from 'react-router'
import PropTypes from 'prop-types'
import {Flex, Box, Spacer} from '@chakra-ui/react'

import Loading from '../../../components/Loading'

import InvoiceStatusTabs from './InvoiceStatusTabs'
import InvoiceTable from './InvoiceTable'
import Actions from './Actions'
import Summary from './Summary'

const TABS = ['allOpen', 'overdue', 'dueThisMonth', 'notYetDue']

const TAB_STATUS_MAP = {
  allOpen: 'all_open',
  overdue: 'overdue',
  dueThisMonth: 'due_this_month',
  notYetDue: 'not_yet_due',
}

const Invoices = ({statementPdfDownloadPath, payerId, payable}) => {
  const [searchParams, setSearchParams] = useSearchParams()

  const perPage = Number(searchParams.get('perPage') ?? 10)

  const [currentTab, setCurrentTab] = useState(() => {
    return TABS[TABS.indexOf(searchParams.get('tab'))] || TABS[0]
  })

  useEffect(() => {
    setSearchParams({perPage, tab: currentTab})
  }, [currentTab, setSearchParams, perPage])

  const status = TAB_STATUS_MAP[currentTab]

  return (
    <Box>
      <Flex alignItems="baseline">
        <InvoiceStatusTabs
          tabs={TABS}
          currentTab={currentTab}
          setCurrentTab={setCurrentTab}
        />
        <Spacer />
        <Actions statementPdfDownloadPath={statementPdfDownloadPath} />
      </Flex>
      <Summary payerId={payerId} status={status} currentTab={currentTab} />
      <Box>
        <Loading>
          <InvoiceTable
            payerId={payerId}
            status={status}
            payable={payable}
            perPage={perPage}
          />
        </Loading>
      </Box>
    </Box>
  )
}

Invoices.propTypes = {
  payerId: PropTypes.string.isRequired,
  statementPdfDownloadPath: PropTypes.string.isRequired,
  payable: PropTypes.bool.isRequired,
}

export default Invoices
